import React from 'react';
export function CompletedIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 3a1 1 0 011-1h11a1 1 0 110 2H4v16h16v-4a1 1 0 112 0v5a1 1 0 01-1 1H3a1 1 0 01-1-1V3z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.707 5.293a1 1 0 00-1.414 0L10.5 15.086l-2.793-2.793a1 1 0 00-1.414 1.414l3.5 3.5a1 1 0 001.414 0l10.5-10.5a1 1 0 000-1.414z"
  }));
}